import { render, staticRenderFns } from "./Kb5.vue?vue&type=template&id=d2bf9f62&scoped=true&"
import script from "./Kb5.vue?vue&type=script&lang=js&"
export * from "./Kb5.vue?vue&type=script&lang=js&"
import style0 from "./Kb5.vue?vue&type=style&index=0&id=d2bf9f62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2bf9f62",
  null
  
)

export default component.exports